<template>
  <b-card>
    <b-row>
      <b-col class="col-12 col-md-4 order-2 order-md-1 mt-4 mt-md-0">
        <address>
          <div><strong>{{ client.name }}</strong></div>
          <div>{{ client.emails.join(', ') }}</div>
          <div>{{ client.mobiles.join(', ') }}</div>
        </address>
      </b-col>
      <b-col v-if="!!membershipCard" class="col-12 col-md-8 col-xl-6 text-center text-md-left order-1 order-md-2">
        <membership-card
          :organization="organization"
          :membership-card="membershipCard"
        ></membership-card>
        <a v-if="addToAppleWalletLink" :href="addToAppleWalletLink" target="_blank" class="p-0" download>
          <img :src="trans('apple_add_to_wallet_logo')" alt="apple add to wallet" style="height:39px">
        </a>
        <b-button variant="link" @click="onClickAddToGoogleWallet" size="sm" :disabled="busy" class="p-0 pl-4">
          <img :src="trans('google_add_to_wallet_logo')" alt="google add to wallet" style="height:39px">
        </b-button>
        <p v-if="error" class="text-danger">
          {{ error }}
        </p>
      </b-col>
      <b-col v-if="isJdmAllowed">
        <jdm-information :organization="organization" @jdm="onJdm"></jdm-information>
      </b-col>
    </b-row>
    <b-button v-if="organization.has_stripe" variant="outline-primary" size="sm" class="mr-2" :disabled="busy" v-b-modal.client-credit-card-on-file-modal>
      <i class="fa fa-fw fa-credit-card"></i>
      {{ trans('cc_on_file') }}
    </b-button>
    <hr>
    <div class="text-muted mb-1">
      <small>{{ trans('client_session_about') }}</small>
    </div>
    <b-row>
      <b-col class="pb-2">
        <b-button variant="branded" size="sm" :href="disconnectUrl">
          {{ trans('disconnect') }}
        </b-button>
      </b-col>
      <b-col class="col-auto pt-1">
        <add-to-home-screen :organization="organization"></add-to-home-screen>
      </b-col>
    </b-row>
    <client-credit-card-on-file-modal
        :organization="organization"
        :client="client"
    ></client-credit-card-on-file-modal>
  </b-card>
</template>

<script>
  import JdmInformation from './JdmInformation'
  import AddToHomeScreen from './../../../common/components/AddToHomeScreen'
  import MembershipCard from './../membership/MembershipCard'
  import ClientCreditCardOnFileModal from './ClientCreditCardOnFileModal'

  export default {
    props: {
      organization: Object,
      client: Object,
    },
    components: {
      JdmInformation,
      AddToHomeScreen,
      MembershipCard,
      ClientCreditCardOnFileModal,
    },
    data() {
      return {
        trans: trans,
        iframeUrlPrefix: _.iframeUrlPrefix,
        jdm: null,
        busy: false,
        error: null,
        showAdminTools: window.SHOW_ADMIN_TOOLS,
      }
    },
    computed: {
      membershipCard() {
        return _.reduce(this.client.memberships || [], (found, m) => {
          if (!found && m.membership_has_card) found = m
          return found
        }, null)
      },
      disconnectUrl() {
        return _.maybeAddSession(`${_.iframeUrlPrefix}/org/${this.organization.id}/client/disconnect`, this.organization)
      },
      addToAppleWalletLink() {
        let membership = _.reduce(this.client.memberships || [], (found, m) => {
          if (!found && m.membership_has_card) found = m
          return found
        }, null)
        if (!membership) return
        return `/org/${this.organization.id}/membership/${membership.membership_id}/add_to_wallet/apple/${membership.recipient_id}/download`
      },
      isJdmAllowed() {
        return this.organization.id == 480 && (this.client?.isJdmAllowed || false)
      },
    },
    methods: {
      onJdm(jdm) {
        this.jdm = jdm
        this.$emit('jdm', this.jdm)
      },
      onClickAddToGoogleWallet() {
        let membership = _.reduce(this.client.memberships || [], (found, m) => {
          if (!found && m.membership_has_card) found = m
          return found
        }, null)
        if (!membership) return
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/membership/${membership.membership_id}/add_to_wallet/google/${membership.recipient_id}`
        axios.get(url)
        .then(response => {
          this.busy = false
          if (response.data.jwt) {
            window.open(`https://pay.google.com/gp/v/save/${response.data.jwt}`, '_blank')
          }
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.myInformation = this
    },
  }
</script>